module.exports = __webpack_public_path__ + "static/img/qq_8.abc29ae6.png";